<template>
	<div>
		<div id="main-nav" class="main-nav" :class="{ sticky: styles.isSticky }">
			<nav class="container-full-width display-flex align-items-center justify-content-space-between">
				<div class="display-flex align-items-center">
					<BaseLink :link="logoLink">
						<img :src="styles.logo" alt="Fundrise logo" style="width: 137px" />
					</BaseLink>
					<slot name="left" />
				</div>
				<div class="display-flex align-items-center">
					<AddFundsButton
						v-if="showAddFunds"
						:class="addFundsButtonStyles"
						button-size="mini"
						data-context="Main Nav"
						data-test="add-funds-button"
					/>
					<slot name="right" />
				</div>
			</nav>
		</div>
	</div>
</template>

<script lang="ts">
export default {
	name: 'DesktopNavTemplate'
};
</script>

<script setup lang="ts">
import AddFundsButton from '@components/account/add-funds-button.vue';
import { computed } from 'vue';
import { HeaderStyle } from 'types/header';
import { Link } from 'types/layout';

interface Props {
	styles: HeaderStyle;
	showAddFunds?: boolean;
}

withDefaults(defineProps<Props>(), {
	showAddFunds: false
});

const addFundsButtonStyles = computed((): string => {
	return `button button-primary mr-100`;
});

const logoLink: Link = { router: 'home' };
</script>
<style lang="scss" scoped>
.container {
	height: inherit;
}
</style>
